<template>
    <div class="buttons-show-screen">
        <router-link :to="previous()" id="btn_listagem" class="is-link" v-if="dadosRequisicao.countLote.length > 1">
            Auditório do Leilão
        </router-link>
        <router-link v-if="loteId" :to="'/leilao/index/leilao_id/'+leilaoId+'/lote/'+loteId" @click.native="loteClicado"
                     id="btn_loteaberto">Detalhes do lote
        </router-link>
        <router-link v-if="interesse && interesse.length > 0" :to="'/leilao/index/leilao_id/'+leilaoId+'/meuslotes'"
                     id="btn_meuslotes">Meus Lotes
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'BotoesRotas',
    props: {
        dadosRequisicao: Object,
        isFavorito: Boolean,
        interesse: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            leilaoId: this.$route.params.id,
            loteId: this.$route.params.idlote
        }
    },
    methods: {
        loteClicado() {
            this.$parent.$emit('loteIdAtualChange', this.loteId)
        },

        previous() {
            if (window.previous_page && window.previous_page.name === 'SalaDisputa') {
                return window.previous_page.fullPath
            }
            return `/leilao/index/leilao_id/${this.$route.params.id}`
        }
    }
}
</script>

<style scoped>
.is-link {
    cursor: pointer;
}

.buttons-show-screen {
    float: left;
}

#btn_listagem,
#btn_loteaberto,
#btn_meuslotes {
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 8px;
    width: 200px;
    text-align: center;
    margin-bottom: 11px;
    font-size: 14px;
    font-weight: 600;
}

#btn_listagem.router-link-exact-active,
#btn_loteaberto.router-link-exact-active,
#btn_meuslotes.router-link-exact-active {
    border-bottom: 3px solid #67302b;
}

#btn_listagem:hover,
#btn_loteaberto:hover,
#btn_meuslotes:hover {
    background: #dbdbdb;
    color: #535353;
    text-decoration: none;
}

@media (max-width: 960px) {
    .buttons-show-screen {
        width: 100%;
    }

    #btn_listagem,
    #btn_loteaberto,
    #btn_meuslotes {
        width: 95%;
        margin-left: 2.4%;
    }
}

@media (max-width: 600px) {
    .buttons-show-screen {
        width: 100%;
    }

    #btn_listagem,
    #btn_loteaberto,
    #btn_meuslotes {
        width: 100%;
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BotoesRotas.vue